import { useWeaponAlertsContext } from "./WeaponAlertsContext";
import { AlertImageDialog } from "./weaponAlertsShared";

/** Full-screen crop viewer — shared by ribbon and expanded grid. */
export default function WeaponAlertsDialog() {
  const { enlarged, setEnlarged } = useWeaponAlertsContext();
  if (!enlarged) return null;
  return <AlertImageDialog alert={enlarged} onClose={() => setEnlarged(null)} />;
}
